import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { MAIN_MAP } from '../../redux/map/Constants';



// TODO: if project.structure.columns (and sitecards to be safe?) hasn't changed then can cache layers and sources created
function withSiteCards (WrappedComponent) {
    class WithSiteCards extends React.Component {
        static propTypes = {
            activeLayers: PropTypes.array.isRequired,
            isDrawing: PropTypes.bool,
            // Redux state
            enabled: PropTypes.bool.isRequired,
            project: PropTypes.object,
            // React router
            match: PropTypes.object.isRequired,
            location: PropTypes.object.isRequired,
            history: PropTypes.object.isRequired
        };

        constructor(props) {
            super(props);
            this.viewSiteCard = this.viewSiteCard.bind(this);
        }

        viewSiteCard = (e) => {
            const { project, history, isDrawing } = this.props;
            const features = e.target.queryRenderedFeatures(e.point, { layers: [`project_${project.id}_site_cards_fill`, `project_${project.id}_site_cards_symbol`] });
            if (!isDrawing && features.length > 0) {
                // REVIEW - Not waiting at least 1 frame causes an internal Mapbox error to be thrown which is hard to debug
                setTimeout(() => { history.push(`/dashboard/sites/${features[0].properties.id}`); }, 1);
                // history.push('/dashboard/sites')
            }
        };

        render () {
            const { activeLayers, enabled, filters, project, ...props } = this.props;
            const newActiveLayers = [...activeLayers];

            if (enabled && project && project.structure && project.numSiteCards > 0) {

                const polygon_point_zoom = 12;
                const polygonLayers = [];
                const sourceGeomLayers = []
                const pointLayers = [];

                // Create style dynamically from the kanban columns
                const styler = project.structure.columnOrder.map((columnId) =>
                    [project.structure.columns[columnId].id, project.structure.columns[columnId].colour]
                ).flat();

                polygonLayers.push({
                    'id': `project_${project.id}_site_cards_fill`,
                    'type': 'fill',
                    // "source": "source_project_site_cards",
                    'source-layer': 'project_site_cards',
                    'paint': {
                        'fill-color': [
                            'match',
                            [
                                'get',
                                'column_id'
                            ],
                            ...styler,
                            '#FFFFFF'
                        ],
                        'fill-opacity': 0.35
                    },
                    'maxzoom': 22,
                    'minzoom': polygon_point_zoom,
                    'onClick': this.viewSiteCard
                });

                polygonLayers.push({
                    'id': `project_${project.id}_site_cards_line`,
                    'type': 'line',
                    // "source": "source_project_site_cards",
                    'source-layer': 'project_site_cards',
                    'paint': {
                        'line-color': [
                            'match',
                            [
                                'get',
                                'column_id'
                            ],
                            ...styler,
                            '#000000'
                        ],
                        'line-width': 3
                    },
                    'maxzoom': 22,
                    'minzoom': polygon_point_zoom
                });

                sourceGeomLayers.push({
                    'id': `project_${project.id}_site_card_source_geometry`,
                    'type': 'line',
                    // "source": "source_project_site_cards",
                    'source-layer': 'project_site_cards',
                    'paint': {
                        'line-color': [
                            'match',
                            [
                                'get',
                                'column_id'
                            ],
                            ...styler,
                            '#000000'
                        ],
                        'line-width': 3
                    },
                    'maxzoom': 22,
                    'minzoom': polygon_point_zoom
                });

                pointLayers.push({
                    'id': `project_${project.id}_site_cards_symbol`,
                    'type': 'symbol',
                    // "source": "source_project_site_cards",
                    'source-layer': 'project_site_cards',
                    'paint': {
                        'icon-color': [
                            'match',
                            [
                                'get',
                                'column_id'
                            ],
                            ...styler,
                            '#FFFFFF'
                        ],

                        // "icon-halo-blur": 1,
                        'icon-halo-color': '#000000',
                        'icon-halo-width': 6
                        // "icon-halo-color": [
                        //     "case",
                        //     ...styler,
                        //     "#000000"
                        // ],
                    },
                    'layout': {
                        'icon-image': 'pin',
                        'icon-size': 2,
                        'icon-anchor': 'bottom',
                        'icon-allow-overlap': true,
                        'icon-ignore-placement': true
                    },
                    'maxzoom': 12,
                    'minzoom': 1,
                    'onClick': this.viewSiteCard
                });

                const filteredExpressions = ['all'];
                filters.children.map(filter => {
                    if (filter.field === 'column') {
                        const filteredColumnIds = filter && filter.properties.values;
                        if (filteredColumnIds && filteredColumnIds.length > 0) {
                            filteredExpressions.push(['in', ['get', 'column_id'], ['literal', filteredColumnIds.map(id => parseInt(id))]]);
                        }
                    } else if (filter.field === 'siteCardName') {
                        const autocompleteValue = filter && filter.properties.value;
                        if (autocompleteValue && autocompleteValue.length > 0) {
                            filteredExpressions.push(['in', autocompleteValue, ['string', ['get', 'name']]]);
                        }
                    }
                });

                newActiveLayers.push({
                    uid: `project_${project.id}_site_card_polygons`,
                    systemName: 'project',
                    visible: true,
                    printable: false,
                    layerData: {
                        ...project.layerData,
                        url: project.layerData.polygonUrl
                    },
                    styling: {
                        'layers': polygonLayers,
                        'source': {
                            'type': 'vector',
                            'maxzoom': 22,
                            'minzoom': polygon_point_zoom
                        }
                    },
                    layerFilter: filteredExpressions.length > 1 ? filteredExpressions : undefined,
                    settings: [],
                    primaryKey: null, // layer.properties.id,
                    highlights: [] // state.highlights.highlightedFeatures.filter(e => e.layerSystemName === layer.system_name),
                });

                newActiveLayers.push({
                    uid: `project_${project.id}_site_card_source_geometry`,
                    systemName: 'project',
                    visible: true,
                    printable: false,
                    layerData: {
                        ...project.layerData,
                        url: project.layerData.lineUrl
                    },
                    styling: {
                        'layers': sourceGeomLayers,
                        'source': {
                            'type': 'vector',
                            'maxzoom': 22,
                            'minzoom': polygon_point_zoom
                        }
                    },
                    layerFilter: filteredExpressions.length > 1 ? filteredExpressions : undefined,
                    settings: [],
                    primaryKey: null, // layer.properties.id,
                    highlights: [] // state.highlights.highlightedFeatures.filter(e => e.layerSystemName === layer.system_name),
                });

                newActiveLayers.push({
                    uid: `project_${project.id}_site_card_points`,
                    systemName: 'project',
                    visible: true,
                    printable: false,
                    layerData: {
                        ...project.layerData,
                        url: project.layerData.pointUrl
                    },
                    styling: {
                        'layers': pointLayers,
                        'source': {
                            'type': 'vector',
                            'maxzoom': polygon_point_zoom,
                            'minzoom': 1
                        }
                    },
                    layerFilter: filteredExpressions.length > 1 ? filteredExpressions : undefined,
                    settings: [],
                    primaryKey: null, // layer.properties.id,
                    highlights: [] // state.highlights.highlightedFeatures.filter(e => e.layerSystemName === layer.system_name),
                });
            }

            return (
                <WrappedComponent
                    activeLayers={newActiveLayers}
                    {...props}
                />
            );
        }
    }

    const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

    WithSiteCards.displayName = `withSiteCards(${wrappedComponentName})`;
    return WithSiteCards;
}

const mapStateToProps = (state, ownProps) => (
    {
        enabled: ownProps.siteCardsEnabled === undefined ? state.siteCard.areSiteCardsVisible : ownProps.siteCardsEnabled,
        filters: state.siteCard.filters,
        project: state.project.currentProject,
        isDrawing: state[MAIN_MAP].isDrawing,
    }
);

export default compose(
    withRouter,
    connect(mapStateToProps, null),
    withSiteCards
);